import { withRouter } from '../../utils/router';
import { SearchFooterContainer } from './SearchFooterContainer';

export const SearchFooterContainerWithRouter = withRouter(
    SearchFooterContainer,
);
